import axios, { AxiosInstance, AxiosResponse } from 'axios';

export interface CreateCouponBatchRequest {
  name: string;
  totalAmount: number;
  allowedValues: number[];
  minOrderValue: number;
  startsAt?: string; // ISO
  expiresAt?: string; // ISO
}

export interface CouponBatch {
  batchId: string;
  cnpj: string;
  name?: string;
  totalAmount: number;
  remainingAmount: number;
  allowedValues: number[];
  minOrderValue: number;
  status: 'ACTIVE' | 'PAUSED' | 'FINISHED' | 'EXPIRED';
  startsAt?: string;
  expiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

class CouponService {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
      timeout: 10000,
    });

    this.client.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  async createBatch(data: CreateCouponBatchRequest): Promise<CouponBatch> {
    try {
      const response: AxiosResponse<CouponBatch> = await this.client.post('/admin/coupons/batches', data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao criar campanha de cupons');
    }
  }

  async listBatches(): Promise<CouponBatch[]> {
    try {
      const response: AxiosResponse<CouponBatch[]> = await this.client.get('/admin/coupons/batches');
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao listar campanhas de cupons');
    }
  }

  async updateBatch(batchId: string, data: Partial<Pick<CouponBatch, 'name' | 'totalAmount' | 'minOrderValue' | 'status'>> & {
    startsAt?: string | null;
    expiresAt?: string | null;
  }): Promise<CouponBatch> {
    try {
      const response: AxiosResponse<CouponBatch> = await this.client.patch(`/admin/coupons/batches/${batchId}`, data);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Erro ao atualizar campanha de cupons');
    }
  }
}

export const couponService = new CouponService();
export default couponService;
